export const SALES_CHANNEL_COPY = {
	title: {
		add: 'Add sales channel',
		edit: 'Edit sales channel',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Document the outlets you will alert during a recall so communication plans stay audit-ready.',
	fields: {
		typeLabel: 'Which sales channel would you notify?',
		nameLabel: 'Which partner or platform runs this channel?',
	},
	actions: {
		removeConfirmTitle: 'Remove this sales channel?',
		removeConfirmDescription:
			'This sales channel will be removed from the plan. You can add it again later.',
	},
	summary: {
		nameMissing: 'Partner details missing.',
	},
}
